import { Option } from 'effect';
import ReactMarkdown, { type Components } from 'react-markdown';

import { markdownRehypePlugins, markdownRemarkPlugins } from './markdownPlugins';

export type MarkdownContentProps = {
  children: string;
  image?: Components['img'];
};

/**
 * The markdown-and-inline-HTML pipeline, with no wrapping element. The plugin
 * chain is {@link markdownRehypePlugins}: it parses inline HTML, sanitises it,
 * and keeps a malformed tag name from failing a server render.
 *
 * Exported on its own so a caller that wraps the pipeline in something of its
 * own — an error boundary, a measurement ref — wraps the pipeline alone, not
 * an extra host element `Markdown` would otherwise force between them.
 */
export function MarkdownContent({ children, image }: MarkdownContentProps) {
  return (
    <ReactMarkdown
      components={Option.match(Option.fromNullishOr(image), {
        onNone: () => ({}),
        onSome: (img) => ({ img }),
      })}
      remarkPlugins={markdownRemarkPlugins}
      rehypePlugins={markdownRehypePlugins}
    >
      {children}
    </ReactMarkdown>
  );
}
